import { UserType } from "root/DataFunctions/Constants";

export const isGovernorRole = ( userType) =>
{
    if (userType === UserType.USER_TYPE_GOVERNOR)
    {
        return true;
    }
    else
    {
        return false;
    }
}